import { render, staticRenderFns } from "./shuttleBox.vue?vue&type=template&id=5d303ae5&scoped=true&"
import script from "./shuttleBox.vue?vue&type=script&lang=js&"
export * from "./shuttleBox.vue?vue&type=script&lang=js&"
import style0 from "./shuttleBox.vue?vue&type=style&index=0&id=5d303ae5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d303ae5",
  null
  
)

export default component.exports